<template>
  <div :class="'col-md-' + col" :style="{'margin': marginSpace}" class="input-multiselect">
    <label>{{ label }}<span v-if="isRequired" class="is-required">*</span></label>
    <div class="input" @click="openSelect = !openSelect" ref="multiselect">
      <span v-if="!selectedValues.length">Selecione</span>
      <div class="show_values_select" v-else-if="selectedValues.length < 3" v-for="(value, index) in selectedValues"
           :key="index">
        <span v-if="isName">{{ value.name }}<button @click.prevent @click.stop="removeItem(value)"><ion-icon
          name="close-circle-outline"></ion-icon></button></span>
        <span v-else>{{ value.label }}<button @click.prevent @click.stop="removeItem(value)"><ion-icon
          name="close-circle-outline"></ion-icon></button></span>
      </div>
      <template v-else>
        <div v-for="(value, index) in selectedValues.slice(1, 3)" :key="index" class="show_values_select">
          <span v-if="isName">{{ value.name }}<button @click.prevent @click.stop="removeItem(value)"><ion-icon
            name="close-circle-outline"></ion-icon></button></span>
          <span v-else>{{ value.label }}<button @click.prevent @click.stop="removeItem(value)"><ion-icon
            name="close-circle-outline"></ion-icon></button></span>
        </div>
        <div>mais...</div>
      </template>
      <div class="button">
        <button @click.prevent v-if="selectedValues.length > 0" @click="removeAll" @click.stop>
          <ion-icon name="close-outline"></ion-icon>
        </button>
        <button @click.prevent>
          <ion-icon v-if="!openSelect" name="chevron-down-outline"></ion-icon>
          <ion-icon v-else name="chevron-up-outline"></ion-icon>
        </button>
      </div>

      <div class="list_container" v-if="openSelect">
        <div class="box-search" v-if="haveSearch">
          <input @click.stop class="search" type="search" v-model="search"
                 placeholder="Digite o nome"/>
          <ion-icon v-if="!search.length" name="search-outline"></ion-icon>
        </div>
        <div class="custom-checkbox" v-for="(option, index) in filteredItems" :key="index">
          <label @click.stop>
            <input class="container-checkbox-input" type="checkbox" :id="'checkbox' + index" v-model="option.isChecked"
                   @change="handleCheckboxChange(option)"/>
            <span v-if="isName">{{ option.name }}</span>
            <span v-else>{{ option.label }}</span>
          </label>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  props: {
    listItems: {
      required: true,
    },
    col: {
      required: true,
    },
    marginSpace: {
      default: '',
    },
    isName: {
      default: false,
    },
    label: {
      default: '',
    },
    haveSearch: {
      default: true,
    },
    isRequired: {
      default: false,
    },
    isOrdened: {
      default: true,
    }
  },
  data() {
    return {
      selectedValues: [],
      selectedString: '',
      search: '',
      openSelect: false,
    };
  },
  methods: {
    removeItem(value) {
      const index = this.selectedValues.indexOf(value);
      if (index > -1) {
        value.isChecked = false;
        this.selectedValues.splice(index, 1);
        this.selectedString = this.selectedValues.map(item => item.id);
      }
    },
    removeAll() {
      this.selectedValues = [];
      this.selectedString = '';
      this.listItems.forEach(option => {
        option.isChecked = false;
      });
    },
    handleCheckboxChange(option) {
      if (option.isChecked) {
        this.selectedValues.push(option);
        this.selectedString = this.selectedValues.map(item => item.id);
      } else {
        const index = this.selectedValues.findIndex(item => item.id === option.id);
        if (index !== -1) {
          this.selectedValues.splice(index, 1);
          this.selectedString = this.selectedValues.map(item => item.id);
        }
      }
    },
    handleOutsideClick(event) {
      if (!this.$refs.multiselect.contains(event.target)) {
        this.openSelect = false;
      }
    }
  },
  watch: {
    selectedValues(newValue, oldValue) {
      this.$emit('selectedValues', newValue);
    },
    selectedString(newValue, oldValue) {
      this.$emit('selectedString', newValue);
    }
  },
  computed: {
    filteredItems() {
      if (this.isOrdened) {
        this.listItems.sort((a, b) => {
          const nameA = (a.hasOwnProperty('name') && a.name.toUpperCase()) || (a.hasOwnProperty('label') && a.label.toUpperCase());
          const nameB = (b.hasOwnProperty('name') && b.name.toUpperCase()) || (b.hasOwnProperty('label') && b.label.toUpperCase());

          if (nameA < nameB)
            return -1

          if (nameA > nameB)
            return 1

          return 0
        })
      }
      const search = this.search.toLowerCase();
      return this.listItems.filter((item) =>
        (item.hasOwnProperty('name') && item.name.toLowerCase().includes(search)) || (item.hasOwnProperty('label') && item.label.toLowerCase().includes(search))
      )
    },
  },
  beforeMount() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  }
};
</script>

<style lang="scss" scoped>
ion-icon {
  pointer-events: none;
}

.input-multiselect {

  label {
    font-size: 14px;
    font-weight: 400;
    color: var(--border-gray);
    margin-bottom: 4px;

    .is-required {
      margin-left: 4px;
      color: #FF445D;
    }

    span {
      font-weight: 400;
      font-size: 14px;
    }
  }

  .input {
    width: 100%;
    height: 36.84px;
    background: #EEF2F7;
    padding: 6px 12px;
    border-radius: 5px !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 16px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    position: relative;

    &:hover {
      box-shadow: inset 0 0 0 1px #CACACA;
    }

    &:focus-visible {
      outline: none;
      border: 1px solid #CACACA;
    }

    .button {
      position: absolute;
      right: 12px;
      top: 12px;
    }

    button {
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
    }

    .show_values_select {
      display: flex;
      align-items: center;
      background-color: rgba(11, 149, 214, .15);
      margin-right: 8px;
      padding: 0 6px;
      gap: 4px;
      border-radius: 4px !important;

      span {
        display: contents;
      }

      button {
        display: block;
        width: 16px;
        height: 16px;
      }
    }

    .list_container {
      width: 100%;
      background: #EEF2F7;
      border: 1px solid #7C7C7C;
      border-radius: 0 0 5px 5px !important;
      display: flex;
      flex-direction: column;
      align-items: start;
      padding: 12px 0;
      margin-top: 5px;
      z-index: 5;
      position: absolute;
      top: 31px;
      left: 0;
      max-height: 300px;
      overflow-y: scroll;

      .box-search {
        width: inherit;
        padding: 0 12px;
        margin-bottom: 8px;
        position: relative;

        .search {
          width: 100%;
          padding: 6px 12px;
          border: none;
          border-radius: 4px !important;
          font-size: 14px;

          &:focus {
            box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.5);
            outline: none;
          }
        }

        ion-icon {
          position: absolute;
          top: 8px;
          right: 24px;
        }
      }

      .custom-checkbox {
        width: 100%;

        &:hover {
          background: rgba(11, 149, 214, .15);
        }

        label {
          display: flex;
          font-weight: 400;
          font-size: 13px;
          color: #3a424e;
          cursor: pointer;
          width: 100%;
          padding: 10px 12px;

          input[type='checkbox'] {
            margin: 0 8px 0 0;
            width: 20px;
            height: 20px;
            background-color: #ffffff;
            border: 0.5px solid #bacadc;
            border-radius: 2px !important;
            cursor: pointer;
            transition: 0.2s;


            &:focus {
              outline: none;
            }
          }
        }
      }
    }

    .list_container::-webkit-scrollbar {
      width: 8px;
    }

    .list_container::-webkit-scrollbar-thumb {
      background: #9c9c9c;
      border-radius: 4px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/inputs/inputMultiSelectOwn.vue